import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Stack } from '@bingads-webui-react/fabric-control';
import { MessageBar, MessageBarBody } from '@fluentui/react-message-bar';
import { RadioGroupLite } from '@bingads-webui-react/primitive-validation-fluent';
import { Radio } from '@fluentui/react-components';

import { ROTATION_OPTIONS, RotationItems } from './constants';

export const ValidatedAdRotation = ({ value, field, disableOptions }) => {
  const i18n = useContext(I18nContext);

  return (
    <div className="ad-rotation">
      <Stack tokens={{ childrenGap: 7 }}>
        <RadioGroupLite
          validationProps={{ field, data: value }}
          value={value}
        >
          {RotationItems.map(option => (
            <Radio key={option.id} value={option.id} label={i18n.getString(option.text)} disabled={disableOptions} />
        ))
        }
        </RadioGroupLite>
        <MessageBar intent="info" layout="auto">
          <MessageBarBody>
            {i18n.getString(_TL_('This ad rotation setting will be ignored if you use an automated bidding bid strategy, as automated bidding prioritizes better-performing ads.'))}
          </MessageBarBody>
        </MessageBar>
      </Stack>
    </div>
  );
};

ValidatedAdRotation.propTypes = {
  value: PropTypes.string,
  field: PropTypes.string.isRequired,
  disableOptions: PropTypes.bool,
};

ValidatedAdRotation.defaultProps = {
  value: ROTATION_OPTIONS.OPTIMIZED_FOR_CLICKS,
  disableOptions: false,
};
